import React from "react";

import { Trans } from "app/utils";

import LandscapeIcon from "components/common/icons/LandscapeIcon";
import PortraitIcon from "components/common/icons/PortraitIcon";
import SquareIcon from "components/common/icons/SquareIcon";
import TallPortraitIcon from "components/common/icons/TallPortraitIcon";
import WideLandscapeIcon from "components/common/icons/WideLandscapeIcon";

interface AspectRatioOptionProps {
  aspectRatio: string;
}

const AspectRatioOption: React.FC<AspectRatioOptionProps> = ({ aspectRatio }) => {
  switch (aspectRatio) {
    case "tall-portrait":
      return (
        <div className="AspectRatio-container">
          <TallPortraitIcon className="AspectRatio-Icon" />
          <span><Trans>Tall Portrait</Trans></span>
          <span className="section">(9:16)</span>
        </div>
      );
    case "portrait":
      return (
        <div className="AspectRatio-container">
          <PortraitIcon className="AspectRatio-Icon" />
          <span><Trans>Portrait</Trans></span>
          <span className="section">(4:5)</span>
        </div>
      );
    case "square":
      return (
        <div className="AspectRatio-container">
          <SquareIcon className="AspectRatio-Icon" />
          <span><Trans>Square</Trans></span>
          <span className="section">(1:1)</span>
        </div>
      );
    case "landscape":
      return (
        <div className="AspectRatio-container">
          <LandscapeIcon className="AspectRatio-Icon" />
          <span><Trans>Landscape</Trans></span>
          <span className="section">(5:4)</span>
        </div>
      );
    case "wide-landscape":
      return (
        <div className="AspectRatio-container">
          <WideLandscapeIcon className="AspectRatio-Icon" />
          <span><Trans>Wide Landscape</Trans></span>
          <span className="section">(16:9)</span>
        </div>
      );
    default:
      return <></>;
  }
};

export default AspectRatioOption;
